export const BpmxLoaderMetadata = {
    name: "bpmx",
    extensions: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".bpmx": { isBinary: true }
    }
};
